import {FormTextField} from "../shared/FormTextField";
import * as React from "react";
import {Divider, Grid, Typography} from "@mui/material";
import {SUBMIX_TYPE_PORRIDGE, SUBMIX_TYPE_SCALD} from "../shared/Types";
import {QuantityIngredientCollectionForm} from "../shared/QuantityIngredientCollectionForm";
import {
  FLOUR_EXCLUSION_UNITS,
  GENERAL_DRY_EXCLUSION_UNITS,
  LIQUID_EXCLUSION_UNITS,
  unitGrams
} from "../shared/Units";
import {UnitSelector} from "../shared/UnitSelector";
import {DecimalFormField} from "../shared/DecimalFormField";

function WeightSubMix(props) {
  const {subMixData, updateSubMixData} = props

  function onStringFieldChange(evt) {
    updateSubMixData({...subMixData, [evt.target.name]: evt.target.value});
  }

  function onMainAmountChange(name, value) {
    updateSubMixData({...subMixData, [name]: value});
  }

  function onFlourChange(flourData) {
    updateSubMixData({...subMixData, flour: flourData});
  }

  function onGrainChange(grainData) {
    updateSubMixData({...subMixData, grain: grainData});
  }

  function onDryChange(dryData) {
    updateSubMixData({...subMixData, dry: dryData});
  }

  function onLiquidChange(liquidData) {
    updateSubMixData({...subMixData, liquid: liquidData});
  }

  function renderPorridgeSubMix() {
    return (
            <div>
              <Grid item>
                <DecimalFormField value={subMixData.mainAmount} size={'small'}
                                  name={'mainAmount'} label={'Soaked Weight'}
                                  onChange={(name, floatVal, id) => onMainAmountChange(name, floatVal)}
                                  id='submix-mainamt' variant='outlined' sx={{marginRight: 1, width: '10ch'}}/>
                <UnitSelector id="submix-mainamtunit" unitValue={subMixData.mainAmountUnit}
                              onValueChange={(id, val) => onMainAmountChange('mainAmountUnit', val)}
                              excludeValues={GENERAL_DRY_EXCLUSION_UNITS} sx={{marginTop: 0}}/>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Grain</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'}>
                  <QuantityIngredientCollectionForm ingredientData={subMixData.grain} setIngredientData={onGrainChange}
                                                    idField={'id'} nameField={'name'} unitField={'amount'}
                                                    unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Grain'}
                                                    excludeUnits={FLOUR_EXCLUSION_UNITS} minCollectionSize={1}/>
                </Grid>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1.5, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Dry Ingredients</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'}>
                  <QuantityIngredientCollectionForm ingredientData={subMixData.dry} setIngredientData={onDryChange}
                                                    idField={'id'} nameField={'name'} unitField={'amount'}
                                                    unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Dry'}
                                                    excludeUnits={GENERAL_DRY_EXCLUSION_UNITS} minCollectionSize={0}/>
                </Grid>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1.5, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Liquid</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'}>
                  <QuantityIngredientCollectionForm ingredientData={subMixData.liquid} setIngredientData={onLiquidChange}
                                                    idField={'id'} nameField={'name'} unitField={'amount'}
                                                    unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Liquid'}
                                                    excludeUnits={LIQUID_EXCLUSION_UNITS} minCollectionSize={1}/>
                </Grid>
              </Grid>
            </div>
    )
  }

  function renderScaldSubMix() {
    return (
            <div>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Flour</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'}>
                  <QuantityIngredientCollectionForm ingredientData={subMixData.flour} setIngredientData={onFlourChange}
                                                    idField={'id'} nameField={'name'} unitField={'amount'}
                                                    unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Flour'}
                                                    excludeUnits={FLOUR_EXCLUSION_UNITS} minCollectionSize={1}/>
                </Grid>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1.5, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Liquid</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'}>
                  <QuantityIngredientCollectionForm ingredientData={subMixData.liquid} setIngredientData={onLiquidChange}
                                                    idField={'id'} nameField={'name'} unitField={'amount'}
                                                    unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Liquid'}
                                                    excludeUnits={LIQUID_EXCLUSION_UNITS} minCollectionSize={1}/>
                </Grid>
              </Grid>
            </div>
    )
  }

  function renderSoakerSubMix() {
    return (
            <div>
              <Grid item>
                <DecimalFormField value={subMixData.mainAmount} size={'small'}
                                  name={'mainAmount'} label={'Soaked Weight'}
                                  onChange={(name, floatVal, id) => onMainAmountChange(name, floatVal)}
                                  id='submix-mainamt' variant='outlined' sx={{marginRight: 1, width: '10ch'}}/>
                <UnitSelector id="submix-mainamtunit" unitValue={subMixData.mainAmountUnit}
                              onValueChange={(id, val) => onMainAmountChange('mainAmountUnit', val)}
                              excludeValues={GENERAL_DRY_EXCLUSION_UNITS} sx={{marginTop: 0}}/>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Dry Ingredients</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'} >
                  <QuantityIngredientCollectionForm ingredientData={subMixData.dry} setIngredientData={onDryChange}
                                                    idField={'id'} nameField={'name'} unitField={'amount'}
                                                    unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Dry'}
                                                    excludeUnits={GENERAL_DRY_EXCLUSION_UNITS} minCollectionSize={1}/>
                </Grid>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1.5, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Liquid</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'} >
                  <QuantityIngredientCollectionForm ingredientData={subMixData.liquid} setIngredientData={onLiquidChange}
                                                    idField={'id'} nameField={'name'} unitField={'amount'}
                                                    unitTypeField={'unit'} defaultUnitType={unitGrams} collectionName={'Liquid'}
                                                    excludeUnits={LIQUID_EXCLUSION_UNITS} minCollectionSize={1}/>
                </Grid>
              </Grid>
            </div>
    )
  }

  return (
    <div>
      <Grid item container marginLeft={-1} marginRight={-1} direction={'column'} justifyContent={'center'}>
        <Grid item>
          <FormTextField size={'small'}
                         sx={{width: '21ch'}}
                         id="submix-name"
                         label={'Name'}
                         name={'name'}
                         value={subMixData.name}
                         onChange={(evt) => onStringFieldChange(evt)}/>
        </Grid>
        <Grid item alignItems={'flex-start'} marginTop={1} marginBottom={1}>
          <FormTextField  sx={{marginTop: 1, marginBottom: 1.5}} multiline rows={3}
                          size={'small'} fullWidth
                          id={'notes'}
                          placeholder={'Notes'}
                          variant={'outlined'}
                          label={'Notes'}
                          name={`notes`}
                          value={subMixData.notes || ''}
                          onChange={(evt) => onStringFieldChange(evt)}/>
        </Grid>
        {subMixData.type === SUBMIX_TYPE_PORRIDGE ? renderPorridgeSubMix()
                : (subMixData.type === SUBMIX_TYPE_SCALD ? renderScaldSubMix() : renderSoakerSubMix())}
      </Grid>
    </div>
  )
}

export {WeightSubMix}
